import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  GenericPdfDownloader,
  schedulePolicyRepayment,
} from "../../../utils/helpers/functions";
import moment from "moment/moment";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const PreviewRenewalEndorsement = ({ modal_id }) => {
  const { customer_policy_details, temp_policy_attach_data } = useSelector(
    (state) => state.policy
  );
  const { all_covers } = useSelector((state) => state?.cover);

  const navigate = useNavigate();
  const close = useRef();
  const renewalEndorsementRef = useRef();

  const { policy_app_details } = customer_policy_details || {};

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => renewalEndorsementRef.current,
    documentTitle: "Renewal Endorsement",
  });

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        policy_app_details-bs-backdrop='static'
        policy_app_details-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div
          className='modal-dialog modal-dialog-scrollable'
          role='document'
          style={{ maxWidth: "700px" }}
        >
          <div className='modal-content rounded-4'>
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Renewal Endorsement
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                style={{ padding: "0px 3px" }}
                onClick={() => {
                  navigate("/admin/customer-policy-view", {
                    replace: true,
                    state: {
                      policyAppNumber: policy_app_details?.policyAppNumber,
                      customerId: policy_app_details?.customerId,
                    },
                  });
                }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body d-none'>
              <div
                className=''
                ref={renewalEndorsementRef}
                id='renewalEndorsementRef'
              >
                <h3 className='text-center mb-2'>Renewal Endorsement</h3>
                <div className='px-2'>
                  <div className='d-flex justify-content-between'>
                    <div className='w-50 mb-1'>
                      <span className='fw-bold me-2 '>Endorsementt No:</span>
                      <span>{policy_app_details?.Endoserment_no}</span>
                    </div>
                    <div className='w-50 mb-1'>
                      <span className='fw-bold me-2 '>Customer Name:</span>
                      <span>
                        {policy_app_details?.customerFirstName +
                          " " +
                          policy_app_details?.customerLastName}
                      </span>
                    </div>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <div className='w-50 mb-1'>
                      <span className='fw-bold me-2'>Policy No: </span>
                      <span className='text-capitalize'>
                        {policy_app_details?.policyAppNumber}
                      </span>
                    </div>
                    <div className='w-50 mb-1'>
                      <span className='fw-bold me-2'>Policy Name:</span>
                      <span className='text-capitalize'>
                        {policy_app_details?.policyName}
                      </span>
                    </div>
                  </div>
                  <div className='col-md-6 mb-1'>
                    <span className='fw-bold me-2'> Office Name:</span>
                    <span className='text-capitalize'>
                      {policy_app_details?.office_name}
                    </span>
                  </div>

                  <div className='row mt-3'>
                    <div>
                      <h5>Attestation</h5>
                      <div className='bg-light p-2 py-3 '>
                        Notwithstanding anything contained herein to the
                        contrary, it is hereby declared and agreed that with
                        effect from{" "}
                        {moment(policy_app_details?.effectiveDate).format(
                          "D-M-Y"
                        )}{" "}
                        to {moment(policy_app_details?.endDate).format("D-M-Y")}
                        , the insurance cover granted by the within policy is
                        renewed for another period of{" "}
                        {policy_app_details?.duration} months as stated below
                      </div>

                      <h5>Risk Covered</h5>
                      <div className='col-md-12'>
                        <table className='table table-centered table-striped nowrap w-100 no-footer'>
                          <thead>
                            <tr>
                              <th
                                className='sorting nowrap'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "130.8px" }}
                                aria-label='Customer: activate to sort column ascending'
                              >
                                Policy Cover Type
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "140.8px" }}
                                aria-label='Customer: activate to sort column ascending'
                              >
                                Cover For
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "108.8px" }}
                                aria-label='Phone: activate to sort column ascending'
                              >
                                Rate(%)
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "147.8px" }}
                              >
                                Sum Insured (&#8358;)
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "147.8px" }}
                                aria-label='Email: activate to sort column ascending'
                              >
                                Annual Premium (&#8358;)
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {temp_policy_attach_data?.risk_covered?.map(
                              (item) => (
                                <tr key={item.id}>
                                  <td>
                                    {
                                      all_covers?.unpaginated_cover?.filter(
                                        (p) =>
                                          String(p.id) ===
                                          String(item?.cover_type)
                                      )[0]?.name
                                    }
                                  </td>
                                  <td>{item.cover_for}</td>
                                  <td className='table-user'>{item.rate}</td>
                                  <td className='table-user'>
                                    {item.sum_insured}
                                  </td>
                                  <td className='text-dark'>
                                    {item.annual_premium}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      <span>
                        In consideration, therefore a renewal premium of{" "}
                        <span className='fw-bold'>
                          {" "}
                          &#8358;
                          {temp_policy_attach_data?.but_charge ||
                            temp_policy_attach_data?.total_annual_premium}
                        </span>{" "}
                        is due from the insured
                      </span>
                      <br />
                      <span>
                        The above is subject to terms, condition and exceptions
                        of the Policy
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-body'>
              <div className=''>
                <div className='row px-2'>
                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2 '>Endorsementt No:</span>
                        <span>{policy_app_details?.Endoserment_no}</span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2 '>Customer Name:</span>
                        <span>
                          {policy_app_details?.customerFirstName +
                            " " +
                            policy_app_details?.customerLastName}
                        </span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2'>Policy No: </span>
                        <span className='text-capitalize'>
                          {policy_app_details?.policyAppNumber}
                        </span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2'>Policy Name:</span>
                        <span className='text-capitalize'>
                          {policy_app_details?.policyName}
                        </span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2'> Office Name:</span>
                        <span className='text-capitalize'>
                          {policy_app_details?.office_name}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div>
                      <h5>Attestation</h5>
                      <div className='bg-light p-2 py-3 '>
                        Notwithstanding anything contained herein to the
                        contrary, it is hereby declared and agreed that with
                        effect from{" "}
                        {moment(policy_app_details?.effectiveDate).format(
                          "D-M-Y"
                        )}{" "}
                        to {moment(policy_app_details?.endDate).format("D-M-Y")}
                        , the insurance cover granted by the within policy is
                        renewed for another period of{" "}
                        {policy_app_details?.duration} months as stated below
                      </div>

                      <h5>Risk Covered</h5>
                      <div className='col-md-12'>
                        <table className='table table-centered table-striped nowrap w-100 no-footer'>
                          <thead>
                            <tr>
                              <th
                                className='sorting nowrap'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "130.8px" }}
                                aria-label='Customer: activate to sort column ascending'
                              >
                                Policy Cover Type
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "140.8px" }}
                                aria-label='Customer: activate to sort column ascending'
                              >
                                Cover For
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "108.8px" }}
                                aria-label='Phone: activate to sort column ascending'
                              >
                                Rate(%)
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "147.8px" }}
                              >
                                Sum Insured (&#8358;)
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "147.8px" }}
                                aria-label='Email: activate to sort column ascending'
                              >
                                Annual Premium (&#8358;)
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {temp_policy_attach_data?.risk_covered?.map(
                              (item) => (
                                <tr key={item.id}>
                                  <td>
                                    {
                                      all_covers?.unpaginated_cover?.filter(
                                        (p) =>
                                          String(p.id) ===
                                          String(item?.cover_type)
                                      )[0]?.name
                                    }
                                  </td>
                                  <td>{item.cover_for}</td>
                                  <td className='table-user'>{item.rate}</td>
                                  <td className='table-user'>
                                    {item.sum_insured}
                                  </td>
                                  <td className='text-dark'>
                                    {item.annual_premium}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      <span>
                        In consideration, therefore a renewal premium of{" "}
                        <span className='fw-bold'>
                          {" "}
                          &#8358;
                          {temp_policy_attach_data?.but_charge ||
                            temp_policy_attach_data?.total_annual_premium}
                        </span>{" "}
                        is due from the insured
                      </span>
                      <br />
                      <span>
                        The above is subject to terms, condition and exceptions
                        of the Policy
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3'>
              <GenericPdfDownloader
                rootElementId={"renewalEndorsementRef"}
                downloadFileName='Renewal Endorsement'
              />
              <button
                type='button'
                className='btn btn-primary btn-sm rounded-3'
                onClick={generatePDF}
              >
                Print
              </button>
              <button
                type='button'
                className='btn btn-success btn-sm rounded-3'
                onClick={() => {
                  close?.current?.click();
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewRenewalEndorsement;
